import React, { Component } from 'react';
import Cropper from 'react-cropper';
import '@babel/register';
import 'babel-polyfill';
import FileDrop from 'react-file-drop';

import ImagePreview from '../../containers/ImagePreview/ImagePreview';
import { SlateDialog } from '../Shared/SlateDialog';
import { avatarShapes } from '../../config/constants';
import {
  isFileImage,
  processImageConsideringOrientation,
  b64toBlob,
} from '../../helpers/imageHelper';
import style from './style';
import './styles.css';
import 'cropperjs/dist/cropper.css';

class AvatarUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      image: null,
      imageTmp: null,
      imagePreviewUrl: null,
      extension: null,
      error: null,
    };
    this.cropper = React.createRef();
  }

  render() {
    let { imagePreviewUrl, image, error } = this.state;
    const { t, type, shape, imageUUID, disabled } = this.props;
    let $imageUploader;

    let open = disabled ? false : this.state.open;

    if (image) {
      $imageUploader = (
        <div className={shape === avatarShapes.CIRCLE ? 'cropper-circle' : ''}>
          <Cropper
            src={image}
            ref={this.cropper}
            style={style.cropper}
            aspectRatio={1 / 1}
            guides={false}
          />
        </div>
      );
    } else {
      $imageUploader = (
        <div>
          <label>
            <div className="avatar-uploader-dialog">
              {error && <span style={style.uploadLabelError}>{error}</span>}
              <p>{t('fileUploader:clickToUpload')}</p>
              <p className="text-small">
                {t('fileUploader:avatarRequirements')}
              </p>
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={this.handleImageChange}
              hidden
            />
          </label>
        </div>
      );
    }

    const actions = [
      {
        label: t('btn:cancel'),
        onClick: this.handleDialogClose,
        variant: 'secondary',
        key: 'cancel',
      },
      {
        label: t('btn:done'),
        onClick: this.handleDone,
        variant: 'primary',
        key: 'done',
      },
    ];

    const hasPhoto = imageUUID || imagePreviewUrl;

    return (
      <div className="avatar-preview">
        <div className="avatar-preview-wrapper">
          <ImagePreview
            image={imagePreviewUrl}
            handleDialogOpen={this.handleDialogOpen}
            imageUUID={imageUUID}
            type={type}
            shape={shape}
            disabled={disabled}
          />
          {hasPhoto && !disabled && (
            <button
              type="button"
              className="avatar-remove-btn"
              onClick={this.handleRemoveProfileImage}
              aria-label={t('fileUploader:removePhoto')}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          )}
        </div>

        <SlateDialog
          open={open}
          onClose={this.handleDialogClose}
          title={t('fileUploader:setProfilePhoto')}
          actions={actions}
          maxWidth="sm"
        >
          <FileDrop onDrop={this.handleDrop}>{$imageUploader}</FileDrop>
        </SlateDialog>
      </div>
    );
  }

  handleDrop = (files) => {
    const file = files[0];
    processImageConsideringOrientation(file, this.updateImage);
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!isFileImage(file)) {
      return;
    }
    processImageConsideringOrientation(file, this.updateImage);
  };

  updateImage = (file) => {
    const url = window.URL.createObjectURL(file);
    this.setState({ image: url });
  };

  crop = () => {
    const dataUrl = this.cropper.current.getCroppedCanvas().toDataURL();
    const base64 = dataUrl.split(',')[1];
    const contentType = dataUrl.substring(
      dataUrl.indexOf(':') + 1,
      dataUrl.indexOf(';'),
    );
    const blob = b64toBlob(base64, contentType);
    const url = window.URL.createObjectURL(blob);

    this.setState(
      {
        imagePreviewUrl: url,
        open: false,
        imageTmp: null,
        currentImageUUID: this.props.imageUUID,
      },
      this.addAttachment(base64, url),
    );
  };

  addAttachment = (base64, url) => {
    this.props.onAddAttachment('base64:' + base64, url);
  };

  handleDialogOpen = () =>
    this.setState({ open: true }, () =>
      document.body.classList.add('dialog-open'),
    );

  handleDialogClose = () => {
    let data;
    if (this.state.imageTmp) {
      let image = this.state.imageTmp;
      if (this.state.imagePreviewUrl) {
        data = { open: false, image: image, imageTmp: null, error: null };
      } else {
        data = { open: false, image: null, imageTmp: null, error: null };
      }
    } else {
      if (this.state.image && !this.state.imagePreviewUrl) {
        data = { open: false, image: null, error: null };
      } else {
        data = { open: false, error: null };
      }
    }
    this.setState(data, () => document.body.classList.remove('dialog-open'));
  };

  handleClearPhoto = () => {
    let imageTmp = this.state.image;
    this.setState({ imageTmp: imageTmp, image: '' });
    this.props.onRestoreAttachment(this.state.currentImageUUID);
  };

  handleRemoveProfileImage = () => {
    this.setState({ image: '', imagePreviewUrl: '' });
    if (this.props.onRemoveAttachment) {
      this.props.onRemoveAttachment();
    }
  };

  handleDone = () => {
    if (this.state.image) {
      this.crop();
      document.body.classList.remove('dialog-open');
    } else {
      this.setState(
        {
          open: false,
          image: null,
          imageTmp: null,
          imagePreviewUrl: null,
        },
        () => document.body.classList.remove('dialog-open'),
      );
    }
  };
}

export default AvatarUploader;
